import { makeAutoObservable } from "mobx";
import { EnterpriseVerifyApply, EnterpriseAuditRequest } from "../../models/EnterpriseAudit";
import { enterpriseAuditApi } from "../../apis/EnterpriseAudit";

export class EnterpriseAuditPageModel {
    candidates: EnterpriseVerifyApply[] = [];
    processed: EnterpriseVerifyApply[] = [];
    selectedAudit: EnterpriseVerifyApply | null = null;
    showRefuseDialog: boolean = false;
    showConfirmDialog: boolean = false;
    refuseReason: string = "";
    loading: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    async loadCandidates() {
        this.loading = true;
        try {
            this.candidates = await enterpriseAuditApi.getAllCandidates();
        } finally {
            this.loading = false;
        }
    }

    async loadProcessed() {
        this.loading = true;
        try {
            this.processed = await enterpriseAuditApi.getAllProcessed();
        } finally {
            this.loading = false;
        }
    }

    setSelectedAudit(audit: EnterpriseVerifyApply | null) {
        this.selectedAudit = audit;
    }

    setShowRefuseDialog(show: boolean) {
        this.showRefuseDialog = show;
        if (!show) {
            this.refuseReason = "";
        }
    }

    setShowConfirmDialog(show: boolean) {
        this.showConfirmDialog = show;
    }

    setRefuseReason(reason: string) {
        this.refuseReason = reason;
    }

    async approveAudit() {
        if (!this.selectedAudit) return;
        
        const request: EnterpriseAuditRequest = {
            id: this.selectedAudit.id,
            approved: true
        };

        this.loading = true;
        try {
            await enterpriseAuditApi.enterpriseAudit(request);
            await this.loadCandidates();
            await this.loadProcessed();
            this.setSelectedAudit(null);
            this.setShowConfirmDialog(false);
        } finally {
            this.loading = false;
        }
    }

    async refuseAudit() {
        if (!this.selectedAudit || !this.refuseReason) return;

        const request: EnterpriseAuditRequest = {
            id: this.selectedAudit.id,
            approved: false,
            refuseReason: this.refuseReason
        };

        this.loading = true;
        try {
            await enterpriseAuditApi.enterpriseAudit(request);
            await this.loadCandidates();
            await this.loadProcessed();
            this.setSelectedAudit(null);
            this.setShowRefuseDialog(false);
        } finally {
            this.loading = false;
        }
    }
} 